export const getPageTitleByDomain = () => {
  const domain = window.location.hostname;
  if (domain.includes('nakednewslive.com')) {
    return 'Naked News Live';
  }

  if (domain.includes('nakednews.com')) {
    return 'Naked News';
  }

  if (domain.includes('nudenews')) {
    return 'Nude News';
  }

  return 'Naked News';
};
